import React from 'react';
import { motion } from 'framer-motion';
import { X } from 'lucide-react';
export function OfferSection() {
  return <section className="py-24 bg-gradient-to-br from-amber-50 to-orange-50" data-id="element-134">
      <div className="max-w-5xl mx-auto px-6" data-id="element-135">
        <motion.div initial={{
        opacity: 0,
        y: 30
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true
      }} transition={{
        duration: 0.6
      }} className="text-center mb-16" data-id="element-136">
          <h2 className="font-serif text-4xl md:text-5xl font-bold text-gray-900 mb-6" data-id="element-137">
            Quanto Custa Ter Lembrancinhas Elegantes?
          </h2>
          <p className="text-xl text-gray-600 max-w-3xl mx-auto" data-id="element-138">
            Vamos fazer as contas juntas...
          </p>
        </motion.div>

        <motion.div initial={{
        opacity: 0,
        y: 30
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true
      }} transition={{
        delay: 0.2,
        duration: 0.6
      }} className="bg-gradient-to-br from-gray-50 to-rose-50 p-10 rounded-3xl shadow-xl mb-12" data-id="element-139">
          <h3 className="text-2xl font-bold text-gray-900 mb-8 text-center" data-id="element-140">
            Lembrancinhas Prontas (Caminho Tradicional)
          </h3>

          <div className="space-y-4 mb-8" data-id="element-141">
            <div className="flex items-center justify-between bg-white p-5 rounded-xl shadow-md" data-id="element-142">
              <span className="text-lg text-gray-700" data-id="element-143">
                Preço médio por unidade:
              </span>
              <span className="text-2xl font-bold text-gray-900" data-id="element-144">
                R$ 5,00 a R$ 20,00
              </span>
            </div>
            <div className="flex items-center justify-between bg-white p-5 rounded-xl shadow-md" data-id="element-145">
              <span className="text-lg text-gray-700" data-id="element-146">
                Para 100 convidados:
              </span>
              <span className="text-2xl font-bold text-red-600" data-id="element-147">
                R$ 500 a R$ 2.000
              </span>
            </div>
            <div className="flex items-center justify-between bg-white p-5 rounded-xl shadow-md" data-id="element-148">
              <span className="text-lg text-gray-700" data-id="element-149">
                Para 200 convidados:
              </span>
              <span className="text-2xl font-bold text-red-600" data-id="element-150">
                R$ 1.000 a R$ 4.000
              </span>
            </div>
          </div>

          <div className="bg-red-100 border-l-4 border-red-500 p-6 rounded-lg" data-id="element-151">
            <div className="flex items-start gap-3" data-id="element-152">
              <X className="w-6 h-6 text-red-600 flex-shrink-0 mt-1" data-id="element-153" />
              <p className="text-lg text-gray-800" data-id="element-154">
                E você ainda corre o risco de ficar "comum", porque todo mundo
                compra nas mesmas lojas.
              </p>
            </div>
          </div>
        </motion.div>

        <motion.div initial={{
        opacity: 0,
        y: 20
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true
      }} transition={{
        delay: 0.4,
        duration: 0.6
      }} className="text-center" data-id="element-155">
          <p className="text-lg text-gray-600 italic" data-id="element-156">
            "Investir R$ 19,90 para economizar centenas ou milhares de reais não
            é gasto. É inteligência."
          </p>
        </motion.div>
      </div>
    </section>;
}